<template>
  <v-alert color="rgba(0,0,0,0)">
    <h3 class="font-weight-bold">Welcome 👋</h3>
    <br />
    <div>
      <p>
        <b>
          I'm Architecting, Developing and Designing Platforms serving MILLIONS
          of users and improving their lives through the ideas I materalize in
          reality.
        </b>
        <br />
        <br />
        During the last 15 years, I've treated my work seriously as a
        <b> OLYMPIAN-LEVEL ATHLETE</b> would do. <br />
        I've decided at the beginning of my life, that I want to perform at the
        World-class level. <br />
        I kept advancing my understanding of the body, soul and the mind,
        evolving myself continously and showcasing it through the Software I'm
        crafting and architecting.
      </p>
      <br />
      <p>
        I've competed succesfully, for years, at the top level in Algorithm
        competitions, while researching and developing most-advanced algorithms.
        <br />
        I've developed my own Operating system, to understand how things work
        from inside out. <br />
        I've also worked with Medical Technology Companies, based in United
        States of America, working with highest-security standards known in the
        Industry; I've also worked with companies from Netherlands, United
        Kingdom, Germany etc..
        <br />
        I've Architected, Designed and Developed, primarily in TypeScript:
        numerous successful Educational, Analytical, SaaS platforms:
        <b> DESIGNED AND TESTED IN SERVING MILLIONS OF USERS.</b>
      </p>
      <br />
      <p>
        I've led teams comprised of 25 members, with complete and detailed
        understanding of <b> THE COMPLETE SOFTWARE DEVELOPMENT CYCLE</b>: from
        architecting, designing, developing backend and frontend platforms, with
        unbridled complexity and utmost simplicity in solutions that solve
        problems and ensure long-term stability. <br />
        My utmost priority is to treat every project and a team member, like a
        <b> OLYMPIAN-LEVEL CHALLENGE and ATHLETE</b>, just like I treat myself
        and hold myself to these standards. I expect and demand same from every
        member. <br />
        I've written and outlined my principles of development that are
        battle-tested, in numerous
        <strong
          >essays, which got recognized and featured by MEDIUM.com staff, on
          their HOMEPAGE</strong
        >, and numerous developers that used them to super-charge their workflow
        and approach to life and work; many of them have since become top-level
        developers and successful people.
      </p>
      <br />
      <p>
        I suggest you to check out my GitHub repositories to find all ideas in
        action. <br />
        From world's best SHOPIFY open-source tool out-there... To robust and
        well-crafted Habit tracker, that is extremely powerful and
        open-source... Operating system, written in C and Assembly,
        bleeding-edge Blockchain projects etc.
      </p>
      <br />
      <p>
        There is a lot of powerful platforms I've designed and crafted,
        published open-source, and I'm sure you will find them valuable and
        useful. <br />
        <b> ALL OF THEM USE BLEADING-EDGE TECHNOLOGIES</b>, different
        development paradigms and always push the envelope on what's possible.
        <br />
        I'm proud of the crafting, and attention to the detail, that goes into
        the ideas I work on.
        <br />
        They are well thought-out and thoroughly hand-crafted pieces of
        <b> ART </b>.
      </p>
      <br />
      <p>
        That being said, if you are a skilled and enthusiastic Architect,
        Developer or Designer,
        <br />
        and if you value similiar ideas and approach as I do, <br />
        and you function similiar to how I do,<br />
        get in touch via e-mail, <br />
        and support open-source projects I'm involved with.
      </p>
      <br />
      <p>Live Long and Prosper!</p>
    </div>
    <div v-if="false">
      <h3 class="font-weight-bold">
        I'm an Architect of Systems and Products, <br />
        with 15+ years of experience building robust, enterprise-grade and
        scalable systems, <br />
        using bleading-edge technologies and architectural paradigms.
      </h3>
      <br />
      <h3 class="font-weight-bold">
        Founded startups in the fields of Education and Sports and led teams of
        up to ten people.
      </h3>
      <br />
      <h3 class="font-weight-regular">
        Worked, as a Systems Architect, Frontend, and Backend Developer, for a
        product company, a digital agency, and as a remote freelancer.
      </h3>
      <br />
      <h3 class="font-weight-regular">
        During my High School days, I've
        <strong>launched and managed web portals</strong> on the topics of
        Sports, Gaming, and IT, worked as an <strong>IT reviewer</strong> for an
        established Croatian site,
        <strong>competed at the National level in Algorithms</strong>, and
        <strong>built an Operating System for 32-bit Computers</strong>.
      </h3>
      <br />
      <h3 class="font-weight-regular">
        Feel free to check the information I featured below, and get in touch if
        you have any interesting challenges.
      </h3>
    </div>
  </v-alert>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IntroComponent',
  components: {
    //
  },
});
</script>
